import { html, LitElement } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import tagStyles from './tag.styles';

export type TagVariant = 'success' | 'neutral' | 'warning' | 'danger';

export type TagSize = 'small' | 'default' | 'large';

export interface TagProps {
	variant?: TagVariant;
	size?: TagSize;
	isSkeleton?: boolean;
}

export class Tag extends LitElement {
	static override styles = [tagStyles()];

	static override get properties() {
		return {
			variant: { type: String },
			size: { type: String },
			isSkeleton: { type: Boolean, attribute: 'is-skeleton' },
		};
	}

	/**
	 * Tag variant.
	 */
	declare variant: TagVariant;

	/**
	 * Tag size.
	 */
	declare size: TagSize;

	/**
	 * Tag skeleton loader.
	 */
	declare isSkeleton: boolean;

	constructor() {
		super();

		this.variant = 'neutral';
		this.size = 'default';
		this.isSkeleton = false;
	}

	override render() {
		return html`
			<span
				class=${classMap({
					tag: true,

					'-success': this.variant === 'success',
					'-neutral': this.variant === 'neutral',
					'-warning': this.variant === 'warning',
					'-danger': this.variant === 'danger',

					'-is-skeleton': this.isSkeleton,

					'-size-small': this.size === 'small',
					'-size-default': this.size === 'default',
					'-size-large': this.size === 'large',
				})}
			>
				${this.isSkeleton ? html`` : html`<slot name="leading"></slot>`}
				<slot></slot>
			</span>
		`;
	}
}

window.customElements.define('m-tag', Tag);

declare global {
	interface HTMLElementTagNameMap {
		'm-tag': Tag;
	}
}
